export default function NotFound() {
return (
    <h1>404 not found</h1>
);
}